import { defineRecipe } from "@chakra-ui/react";

export const dialogHeaderRecipe = defineRecipe({
  base: {
    px: 6,
    py: 5,
    mb: 3,
    bg: "#e9ebed",
    fontWeight: 600,
    fontSize: "1rem",
  },
});

export const dialogContentRecipe = defineRecipe({
  base: {
    borderRadius: 10,
    overflow: "hidden",
  },
});

export const dialogBodyRecipe = defineRecipe({
  base: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  variants: {
    visual: {
      withoutTitle: {
        pt: 5,
      },
    },
  },
});
